import { gql, TypedDocumentNode } from '@apollo/client'

import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { DomainAmazonSliceDTO } from './types'

export const DOMAIN_AMAZON_OPTION_FRAGMENT: TypedDocumentNode<DomainAmazonSliceDTO> = gql`
  ${ALERT_FRAGMENT}

  fragment DomainAmazonOptionFragment on DomainAmazon {
    enabled
    id
    domain {
      activeAbTest {
        id
      }
      alerts {
        ...AlertFragment
      }
      name
    }
  }
`
